import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment-timezone";
import {
  fetchReservations,
  postReservationAccept,
  tablesToChange as fetchTablesToChange,
  changeTables,
  getReservationSums,
  fetchTables,
  fetchConnectTablesConfig,
  fetchAllReservations,
  resetAttendance,
  fetchLastReservationsWithChatMessages,
  fetchFilters,
} from "../actions/restaurantActions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FiCopy } from "react-icons/fi";
import { toast } from "react-toastify";
import {
  fetchZones,
  fetchReservationBlockedWeekdays,
  checkCancelAction,
  updateReservation,
  postPhoneOrEmailConfirmation,
  getRestaurantTimeZone,
} from "../actions/reservationsActions";
import ReservationHistory from "../components/ReservationHistory";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import SwitchLabelButton from "../components/SwitchLabelButton";
import UsePrevious from "../components/UsePrevious";
import TablesModal from "../components/ChangeTables";
import WaitCheckMark from "../components/WaitCheckMark";
import AttendanceButtons from "../components/AttendanceButtons";
import NotificationBell from "../components/NotificationBell";
import CustomDatePickerReservationSums from "../components/CustomDatePickerReservationSums";
import ReservationScreen from "./ReservationScreen";
import FiltersComponent from "../components/FiltersComponent";
import ReservationChat from "../components/ReservationChat";
import styled from "styled-components";
import CustomSelect from "../components/SelectableCustom";
import CustomSelectArray from "../components/CustomSelectArray";
import CustomSelectArrayOfObjects from "../components/CustomSelectArrayOfObjects";
import { Row, Col, Card, Modal, Table, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faPlus,
  faCalendar,
  faFilter,
  faSun,
  faMap,
  faCircleDot,
  faStopwatch,
  faChair,
  faUsers,
  faCircleXmark,
  faFilePen,
  faRectangleXmark,
  faEnvelope,
  faWheelchairMove,
  faBaby,
  faBell,
  faReply,
  faSearch,
  faSquareCheck,
  faEye,
  faPhone,
  faCircleCheck,
  faGear,
  faXmark,
  faCheck,
  faPhoneSlash,
  faLock,
  faChartColumn,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import Separator from "../components/Separator";
import LoaderComponent from "../components/LoaderComponent";
import ReservationStatusBox from "../components/ReservationStatusBox";
import CompareChanges from "../components/CompareChanges";
import ShowCustomerInfo from "../components/ShowCustomerInfo";
import { TableIconSvg } from "../icons/SvgIcons";
import {
  CalendarSvgIcon,
  FilterSvgIcon,
  GearSvgIcon,
  NoPhoneSvgIcon,
  OnOffSvgIcon,
  PhoneSvgIcon,
  PlusSvgIcon,
  ReservationSvgIcon,
  TableSvgIcon,
  UsersSvgIcon,
  XSvgIcon,
  UserSvgIcon,
  ClockSvgIcon,
  BellSvgIcon,
  BubbleTextSvgIcon,
  ZoneSvgIcon,
  PennotebookSvgIcon,
  ExtrasSvgIcon,
  ArrowUpDownIcon,
  ArrowUpDown,
  NoPhoneTwoLinesSvgIcon,
} from "../icons/SvgIcons";
import DropDownButton from "../components/DropDownButton";
import ReservationCard from "../components/ReservationCard";
import {
  DefaultDate,
  CloseIcon,
  CardHeader,
  CardHeaderTitle,
  statusGroups,
} from "../components/DefaultImports";
import { CustomModal } from "../components/CustomModal";
import SelectableStatusOptions from "../components/inputs/SelectableStatusOptions";
import { ConfirmationModal } from "../components/ConfirmationModal";

import { createReservationSlice } from "../reducers/reservationReducers";

import DropdownSortItems from "../components/inputs/DropdownSortItems";

import { useOnlineStatus } from "../components/ConectionStatus";

import ReservationStatusChanger from "../components/Reservations/ReservationStatusChanger";

const ModernButton = styled.button`
  padding: 5px 8px;
  background-color: #007bff;
  color: white;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056b3;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 30px;
  padding-top: 60px;

  @media (max-width: 768px) {
    padding: 0px;
    padding-top: 0;
    margin: 0;
  }
`;

const ReservationContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-right: 5px;
  padding-bottom: 10px;
  overflow-y: auto; /* Add vertical scroll if content exceeds height */
  overflow-x: hidden; /* Hide horizontal overflow */

  /* Style the scrollbar */
  &::-webkit-scrollbar {
    width: 8px; /* Scrollbar width */
    padding-bottom: 10px !important;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; /* Light gray track */
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Darker gray thumb */
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Slightly darker on hover */
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  gap: 20px;
  margin-bottom: 1rem;
`;

const FilterItem = styled.div`
  margin: 0px;
`;

const FilterLabel = styled.label`
  display: block;
  margin: 0;
  font-size: 1.1rem;
`;

const FilterInput = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const FilterSelect = styled.select`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const ReservationGrid = styled.div`
  display: grid;
`;
/* 
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
 */

const ReservationTop = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 35px;
  background-color: #99b0ad;
  color: #faf6e9;
  /*   background-color: ${(props) =>
    props.status === "Cancelled" ||
    props.status === "Cancelled_By_Customer" ||
    props.status === "Cancelled_By_Restaurant" ||
    props.status === "Did_Not_Attend"
      ? "#e8733c"
      : props.status === "Pending_from_customer_Warning"
      ? "#d6a7c1"
      : props.status === "Edited"
      ? "#7e538a"
      : props.status === "Pending_from_restaurant"
      ? "#cacf44"
      : props.status === "Pending_from_customer"
      ? "#959657"
      : props.status === "Late"
      ? "#ebb052"
      : "#58c49f"}; */
`;

const ReservationBot = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  height: auto;
`;

const ReservationBotItems = styled.div`
  display: flex;
  margin: 5px;
  font-size: 18px;
`;
const ReservationBotItemss = styled.div`
  display: flex;
  margin: 4px;
`;
const ReservationBoxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  margin: 0;
  width: 100%;
`;
const ReservationBotItemsContainer = styled.div`
  display: flex;
  width: 100%;
`;

const ReservationFlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-right: 5px;
`;

const ReservationTitle = styled.h2`
  display: flex;
  font-size: 1rem;
  color: ${(props) =>
    props.status === "Cancelled"
      ? "#FAF6E9"
      : props.status === "Pending_from_restaurant"
      ? "black"
      : props.status === "Edited"
      ? "#FAF6E9"
      : "#FAF6E9"};
  margin-top: 4px;
  margin-left: 5px;
`;

const ReservationDate = styled.h2`
  font-size: 1rem;
  color: ${(props) =>
    props.status === "Cancelled"
      ? "white"
      : props.status === "Pending_from_restaurant"
      ? "black"
      : props.status === "Edited"
      ? "white"
      : "white"};
  margin-top: 0px;
  margin-left: 5px;
`;

const AttendanceButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: auto;
  height: auto;
`;

const FirstWarningMessage = styled.div`
  display: flex;
  gap: 10px;
  position: absolute;
  top: 0.2rem;
  right: 4rem;
  color: #d15823;
`;

const ReservationInfo = styled.p`
  margin-bottom: 1rem;
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-color: #007bff;
  border: 1px solid #007bff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 4px;

  &:hover {
    background-color: #0069d9;
    border-color: #0062cc;
  }
`;

const SuccessButton = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #a5d9d7;
  border: 1px solid #e8e6e6;
  width: 50%;
  height: 100%;
  padding: 0;
  margin: 0;
  border-radius: 0;
`;

const DangerButton = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #a5d9d7;
  border-radius: 0;
  border: 1px solid #e8e6e6;
  padding: 0;
  width: 50%;
  height: 100%;
  margin: 0;
`;

const EditButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #59d9d4;
  border: 0;
  top: 0;
  left: 0;
  height: 28px;
  width: 100%;
  padding: 0;
  margin: 0;
  border-radius: 0;
  &:hover {
    background-color: #228a86;
  }
`;

const StyledIcon = styled(FontAwesomeIcon)`
  margin: 0;
  padding: 0;
  font-size: 28px;
`;

const SuccessButtonFilter = styled(Button)`
  width: 100px;
  background-color: #00b33c;
  border-color: #00b33c;

  &:hover {
    background-color: #80ffaa;
    border-color: #80ffaa;
  }
`;

const DateFilterContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: start;
  margin-bottom: 1rem;
`;

const OtherFiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const DateButton = styled.div`
  cursor: pointer;
  display: flex;
  padding: 0;
  height: 32px;
  border-radius: 5px;
  border: 0px solid gray;
  width: auto;
  overflow: hidden;
  margin-bottom: 5px;
`;
const DateButtonLeft = styled.div`
  padding: 0;
  background-color: #99b0ad;
  height: 100%;
  width: 30px;
  text-align: center;
  border-right: 0px solid gray;
  cursor: pointer;
`;
const DateButtonRight = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: gray;
  background-color: white;
  text-align: center;
  width: auto;
  cursor: pointer;
  padding: 5px;
  border-right: 0px solid gray;
  border-radius: 0 5px 5px 0;
`;
const WeekDayRight = styled.div`
  display: flex;
  background-color: white;
  align-items: center;
  font-size: 12px;
  color: gray;
  text-align: center;
  width: 35px;
  cursor: pointer;
  padding-left: 5px;
`;

const FilterButton = styled.div`
  cursor: pointer;
  display: flex;
  padding: 0;
  margin: 0;
  height: auto;
  border-radius: 5px;
  border: 0x solid gray;
  width: 100%;
  overflow: hidden;
`;
const FilterButtonLeft = styled.div`
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  background-color: #99b0ad;
  height: auto;
  width: 30px;
  border-right: 0px solid gray;
  cursor: pointer;
  align-items: center;
`;
const FilterButtonRight = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: gray;
  background-color: white;
  text-align: start;
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: 0;
  margin: 0;
  overflow-x: auto;

  /* Modern Scrollbar Style */
  &::-webkit-scrollbar {
    width: 10px; /* Adjust width for vertical scrollbar */
    height: 10px; /* Adjust height for horizontal scrollbar */
  }

  &::-webkit-scrollbar-track {
    background-color: #f4f4f4; /* Color of the track of scrollbar */
    border-radius: 10px; /* Adjust border-radius for the track */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #bdbdbd; /* Color of the thumb of scrollbar */
    border-radius: 10px; /* Adjust border-radius for the thumb */
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #a8a8a8; /* Color of the thumb of scrollbar when hovered */
  }

  /* For Internet Explorer */
  -ms-overflow-style: auto;
`;
const StyledCard = styled(Card)`
  margin: 10px 0;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  border: 0;
`;

const CardTop = styled.div`
  padding: 10px;
  min-height: 50px;
  background-color: #faf6e9;
  justify-content: center;
`;

const CardBottom = styled.div`
  padding: 5px;
  background-color: #8febc5;
`;

const CreateZoneButton = styled(ModernButton)`
  position: absolute;
  display: flex;
  top: 10px;
  right: 11px;
  background-color: #99b0ad;
  &:hover {
    background-color: #bbbbbb;
  }
`;

const CreateZoneButtonWaitingList = styled(ModernButton)`
  position: absolute;
  display: flex;
  top: 45px;
  right: 11px;
  background-color: #59d9d4;
  &:hover {
    background-color: #228a86;
  }
`;

const LargeIconPlus = styled(FontAwesomeIcon)`
  margin-left: 7px;
  color: #faf6e9;
`;

const CancelIcon = styled(FontAwesomeIcon)`
  top: 3px;
  right: 3px;
  position: absolute;
  --fa-primary-color: #d35612;
  --fa-secondary-color: #ffffff;
`;

const TableBox = styled.div`
  display: inline-block;
  margin: 2px;
  width: auto;
  height: 25px;
  padding-left: 3px;
  padding-right: 3px;
  line-height: 25px;
  text-align: center;
  background-color: #3ecf95;
  color: white;
  border: 1px solid gray;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  box-sizing: border-box;
`;

const ModalBackgroundToCustomDate = styled.div`
  position: fixed;
  z-index: 110;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

const CustomDateContainer = styled.div`
  position: fixed;
  width: auto;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%); // centers the div
  z-index: 120;
`;

const StyledH7 = styled.div`
  font-size: 15px;
  color: #faf6e9;
`;

const SearchIcon = styled(FontAwesomeIcon)`
  position: absolute;
  right: 5px;
  top: 5px;
`;

const SearchBarLeft = styled.div`
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  background-color: #99b0ad;
  width: 30px;
  border-right: 0px solid gray;
  cursor: pointer;
  align-items: center;
  height: 30px;
  margin-top: 5px;
  border-radius: 5px 0px 0px 5px;
`;

const SearchBar = styled.div`
  margin-top: 5px;
  position: relative;
  width: 100%;
  height: 30px !important;

  border-radius: 8px; /* optional for softer look */
  transition: box-shadow 0.2s ease;
`;

const SearchInput = styled.input`
  font-size: 14px;
  border-radius: 0px 5px 5px 0px;
  border: none;
  padding-left: 6px;
  height: 30px;
  width: 100%;
  outline: none;
  color: #99b0ad;

  box-shadow: ${(props) =>
    props.active ? "inset 0 0 0 1px rgba(238, 117, 76, 0.7)" : "none"};

  &:focus {
    border: none;
    outline: none;
    box-shadow: none;
    color: #99b0ad;
  }
`;

const SuggestionBox = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  background: white;
  border-top: none;
  width: 100%;
  color: #99b0ad;
  max-height: 120px;
  overflow-y: auto;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const SuggestionItem = styled.div`
  padding: 6px 10px;
  font-size: 0.8rem;
  cursor: pointer;
  color: #99b0ad;
  &:hover {
    background-color: #f1f1f1;
  }
`;

const FormCheck = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  padding-bottom: 3px;
`;

const StyledCheckbox = styled.input.attrs({ type: "checkbox" })`
  &.makeItGreen:checked {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%2300A400' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 75%;
  }
`;

const FilterBoxes = styled.div`
  display: flex;
  white-space: nowrap;
  align-items: center;
  font-size: 10px;
  justify-content: center;
  min-width: 50px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid black;
  padding: 3px;
  margin: 2px 1px 2px 1px;
  color: #ffffff;
  overflow: hidden;
  background-color: ${(props) =>
    props.backgroundColor !== null ? props.backgroundColor : "#ffffff"};
`;

const TablesUsedSeatSums = styled.div`
  color: ${(props) =>
    props.reservation_number > props.total_number_of_seats ? "red" : "#5ace8c"};
`;

const CustomRow = styled.div`
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  height: auto;
  align-items: center;
  display: flex; /* Ensures flex properties apply correctly */
`;

const SelectableStatusCol = styled(Col)`
  display: flex;
  flex-wrap: nowrap;
  margin-top: 6px;
  justify-content: end;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    justify-content: start;
    padding-left: 4px;
    padding-top: 5px;
  }
`;

const TimeColStyled = styled(Col)`
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 10px;
  padding-top: 10px;

  @media (max-width: 768px) {
    padding-bottom: 4px;
    padding-top: 2px;
  }
`;

function getTableInfo(selectedTablesList, allTablesList) {
  let tableInfo = {};

  Object.keys(selectedTablesList).forEach((zoneName) => {
    const tableNumbers = selectedTablesList[zoneName].map(
      (table) => table.number
    );

    allTablesList.forEach((tablesInZone) => {
      if (tablesInZone[0] === zoneName) {
        tableNumbers.forEach((tableNumber) => {
          const tableDetails = tablesInZone.find(
            (table) => table.split(";")[0] === tableNumber
          );
          if (tableDetails) {
            if (tableInfo[zoneName]) {
              tableInfo[zoneName].push(tableDetails);
            } else {
              tableInfo[zoneName] = [tableDetails];
            }
          }
        });
      }
    });
  });

  // Convert the object into a list of lists
  let tableInfoList = [];
  Object.keys(tableInfo).forEach((zone) => {
    tableInfoList.push([zone, ...tableInfo[zone]]);
  });

  return tableInfoList;
}

function listToSelectedTablesFormat(zoneName, tableNumbers) {
  if (!Array.isArray(tableNumbers)) {
    throw new Error("Expected parameter to be an array");
  }

  const tables = tableNumbers.map((tableNumber) => ({
    number: tableNumber,
    status: "0",
  }));

  return {
    [zoneName]: tables,
  };
}

function ReservationFromRestaurantScreen() {
  const reservationsFromRestaurant = useSelector(
    (state) => state.reservationsFromRestaurant
  );
  const onlineStatus = useOnlineStatus();
  const {
    reservations,
    isLoading = false,
    error,
    allReservations,
    lastReservationsWithChatMessages,
  } = reservationsFromRestaurant;

  const tablesChangeds = useSelector((state) => state.changedTables);
  const { tablesChanged = [], isLoadingChangeTables } = tablesChangeds;

  const dispatch = useDispatch();
  const id = useParams();

  const today = new Date();
  const lastManualUpdate = useRef(null);
  const formattedToday = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  const [dateFilter, setDateFilter] = useState(formattedToday);
  const [placeFilter, setPlaceFilter] = useState("");
  const [attendedOrNot, setAttendedOrNot] = useState([
    "Compareceu",
    "Não compareceu",
  ]);
  const [data, setData] = useState(null);
  const prevData = UsePrevious(data);
  const [statusFilter, setStatusFilter] = useState(
    id.status === "all_pending_reservations" ? id.status : "Todos"
  );
  const [showModal, setShowModal] = useState(false);
  const [tokens, setTokens] = useState("");
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [isReservationModalOpen, setIsReservationModalOpen] = useState(false);
  const [isCreatingReservation, setIsCreatingReservation] = useState(false);

  const [reset, setReset] = useState(false);
  const [isAllReservations, setIsAllReservations] = useState(false);
  const [theReservations, setTheReservations] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState("");

  const [isOpenTimeFilters, setIsOpenTimeFilters] = useState(false);

  const [reservationsWithChatMessages, setReservationsWithChatMessages] =
    useState([]);

  const [customer_name, setCustomer_name] = useState("");
  const [reservationTokenToPhoneLink, setReservationTokenToPhoneLink] =
    useState("");

  const [selectedReservation, setSelectedReservation] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [updatedZones, setZonesWithAll] = useState("");
  const [tokena, setTokena] = useState("");
  const [restaurant_id, setRestaurant_id] = useState("");
  const [tablesList, setTablesList] = useState("");
  const [isWaiting, setIsWaiting] = useState(false);
  const [acceptMultipleReservations, setAcceptMultipleReservations] =
    useState(false);
  const [canceltMultipleReservations, setCanceltMultipleReservations] =
    useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [selectedMultipleReservations, setSelectedMultipleReservations] =
    useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activateLoader, setActivateLoader] = useState(false);
  const [sortedResults, setSortedResults] = useState([]);
  const [sortedResultsAllStatus, setSortedResultsAllStatus] = useState([]);
  const [all_reservations, setAll_reservations] = useState([]);
  const [showNoTablesMessage, setShowNoTablesMessage] = useState(false);
  const [dropDownFilterButton, setDropDownFilterButton] = useState("Horário");

  const [reservationErrorModal, setReservationErrorModal] = useState(false);
  const [reservationSuccessModal, setReservationSuccessModal] = useState(false);
  const [reservationRetry, setReservationRetry] = useState(false);

  const [
    showModalInternetConectionFailure,
    setShowModalInternetConectionFailure,
  ] = useState(false);

  const [hasSelectedSuggestion, setHasSelectedSuggestion] = useState(false);
  const [isSugestionActive, setIsSugestionActive] = useState(false);
  const searchRef = useRef(null);

  const [reservationHasBeenModified, setReservationHasBeenModified] =
    useState(false);
  const [
    modalReservationModifyReservation,
    setModalReservationModifyReservation,
  ] = useState(false);

  const [isShowCustomerInfoModalActive, setIsShowCustomerInfoModalActive] =
    useState(false);

  const [reservation_or_waiting_list, setReservation_or_waiting_list] =
    useState("reservation");
  const reservation_or_waiting_list_options = ["reservation", "waiting_list"];

  const [websocketStatus, setWebsocketStatus] = useState("disconected");

  const [selectedStatus, setSelectedStatus] = useState([
    "A CHEGAR",
    "ATRASADA",
    "À PORTA",
    "REST",
    "CLIENTE",
    //"ESPERA",
    "FINALIZADA",
    "CANCELADAS",
    "Mesa livre",
  ]);

  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [phoneIsConfirmed, setPhoneIsConfirmed] = useState(false);
  const [completePhone, setCompletePhone] = useState("");

  const [current_reservation_id, setCurrent_reservation_id] = useState("");

  const reservationAccept = useSelector((state) => state.reservationAccept);
  const { messageAccept, isLoadingAccept } = reservationAccept;

  const reservationCancel = useSelector((state) => state.cancelReservation);
  const { cancelMessage, isLoadingCancel } = reservationCancel;

  const reservationZone = useSelector((state) => state.reservationZone);
  const { zones, isZonesLoading, zonesError } = reservationZone;

  const customerAttendUpdates = useSelector(
    (state) => state.customerAttendUpdate
  );
  const {
    customerAttend,
    isLoadingCustomerAttend,
    errorCustomerAttend,
    isLoadingChangeTableNumber,
    changeTableNumber,
    errorChangeTableNumber,
  } = customerAttendUpdates;

  const restaurant_info = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurant_info;

  const reservation_info = useSelector(
    (state) => state.reservationCustomersMenu
  );
  const { reservation } = reservation_info;

  const restaurantTimeZone = useSelector(
    (state) => state.reservationBlockedWeekDays.restaurantTimeZone
  );

  const reservation_created_selector = useSelector(
    (state) => state.createReservation
  );
  const {
    reservation_created,
    checkCancel,
    isCheckCancelLoading,
    createReservationFailed,
    createReservationSuccess,
  } = reservation_created_selector;

  const all_tables = useSelector((state) => state.restaurantTables.tables);

  const fetchedFilters = useSelector(
    (state) => state.filtersModels.fetchedFilters
  );

  const tablesToChange = useSelector((state) => state.availableTablesToChange);
  const { tables = [], isLoadingTables, errorTables } = tablesToChange;

  const connectTables = useSelector((state) => state.connectTablesConfig);
  const { connectTablesConfig = [] } = connectTables;

  const manager_info = useSelector((state) => state.crudManager);
  const { managerInfo } = manager_info;

  const { createReservationSuccessErrorReset } = createReservationSlice.actions;

  const [showTablesModal, setShowTablesModal] = useState(false);

  const [usedTables, setUsedTables] = useState({});

  const [containerHeight, setContainerHeight] = useState(0);
  const containerRef = useRef(null);
  const topContainerRef = useRef(null);

  const prevRestaurantIdRef = useRef(null);

  useEffect(() => {
    if (createReservationFailed === true) {
      setReservationErrorModal(true);
    } else {
      setReservationErrorModal(false);
    }

    if (createReservationSuccess === true) {
      setReservationSuccessModal(true);
    } else {
      setReservationSuccessModal(false);
    }
  }, [createReservationFailed, createReservationSuccess]);

  useEffect(() => {
    if (error) {
      setShowModalInternetConectionFailure(true);
    } else {
      setShowModalInternetConectionFailure(false);
    }
  }, [error]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setHasSelectedSuggestion(true); // This hides the suggestions
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const currentId = restaurants?.id;

    if (currentId && prevRestaurantIdRef.current !== currentId) {
      prevRestaurantIdRef.current = currentId;

      dispatch(fetchTables(currentId));
      dispatch(fetchConnectTablesConfig(currentId));
      dispatch(fetchReservationBlockedWeekdays(currentId));
      dispatch(getRestaurantTimeZone(currentId));
      dispatch(fetchFilters(currentId));

      console.log("Fetching for restaurant ID:", currentId);
      handleReservationSuccessOrErrorReset();
    }
  }, [restaurants, onlineStatus]);

  useEffect(() => {
    if (restaurants && Object.keys(restaurants).length > 0) {
      dispatch(getReservationSums(restaurants.id, dateFilter));
    }
  }, [restaurants, onlineStatus, dateFilter]);

  useEffect(() => {
    if (!restaurants?.id) return; // guard

    let ignore = false;

    (async () => {
      try {
        await dispatch(
          fetchReservations(restaurants.id, dateFilter, statusFilter)
        );
        if (ignore) return;
        // optional: do something after it resolves
      } catch (err) {
        console.error(err);
      }
    })();

    return () => {
      ignore = true;
    }; // prevent state updates after unmount
  }, [dispatch, restaurants?.id, dateFilter, statusFilter]);
  useEffect(() => {
    if (restaurants && Object.keys(restaurants).length > 0) {
      dispatch(fetchZones(restaurants.id));
    }
  }, [restaurants, dateFilter]);

  useEffect(() => {
    const calculateHeight = () => {
      const topOffset = containerRef.current?.getBoundingClientRect().top || 0;
      setContainerHeight(window.innerHeight - topOffset - 10);
    };

    calculateHeight(); // initial

    window.addEventListener("resize", calculateHeight);

    const observer = new ResizeObserver(calculateHeight);
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      window.removeEventListener("resize", calculateHeight);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const calculateHeight = () => {
      const topOffset = containerRef.current?.getBoundingClientRect().top || 0;
      setContainerHeight(window.innerHeight - topOffset - 10);
    };

    calculateHeight();
    window.addEventListener("resize", calculateHeight);
    console.log("its rezising");

    return () => {
      window.removeEventListener("resize", calculateHeight);
    };
  }, []);

  async function dispatch_reservation_wait() {
    try {
      setIsWaiting(true);

      await Promise.all([
        dispatch(fetchReservations(restaurants?.id, dateFilter)),
        dispatch(fetchLastReservationsWithChatMessages(restaurants?.id)),
        dispatch(
          fetchAllReservations(
            restaurants?.id,
            null,
            null,
            null,
            "all_pending_reservations_from_all_time"
          )
        ),
      ]);
    } finally {
      setIsWaiting(false);
    }
  }

  useEffect(() => {
    setAll_reservations(allReservations);
  }, [allReservations]);

  useEffect(() => {
    if (restaurantTimeZone) {
      setCurrentDateTime(moment.tz(restaurantTimeZone.timezone));
      console.log("timezone--: ", restaurantTimeZone);
    }
  }, [restaurantTimeZone]);

  useEffect(() => {
    if (isLoading === false || isLoadingChangeTableNumber === false) {
      setActivateLoader(false);
    } else {
      setActivateLoader(true);
    }
  }, [isLoading, isLoadingChangeTableNumber]);

  useEffect(() => {
    if (restaurantTimeZone) {
      const timer = setInterval(() => {
        setCurrentDateTime(moment.tz(restaurantTimeZone.timezone));
      }, 60000); // 60,000 milliseconds = 1 minute

      // Cleanup: clear the interval when the component is destroyed
      return () => clearInterval(timer);
    }
  }, [restaurantTimeZone]);

  function deepEqual(obj1, obj2) {
    if (obj1 === obj2) return true;

    if (
      typeof obj1 !== "object" ||
      obj1 === null ||
      typeof obj2 !== "object" ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }
  useEffect(() => {
    if (reservations && allReservations) {
      let isReservationsAll = false;
      let shouldUpdate = false;
      let allTokensPresent = true;

      if (isAllReservations && allReservations.length > 0) {
        isReservationsAll = true;
        // Check if every token in allReservations is present in theReservations
        let allTokensPresent = true;
        if (Array.isArray(theReservations)) {
          allTokensPresent = deepEqual(allReservations, theReservations);
        }
        // Update only if not all tokens are present
        if (!allTokensPresent) {
          shouldUpdate = true;
        }
      } else {
        isReservationsAll = false;
        setIsAllReservations(false);
        // Similar logic could be applied for `reservations` and `theReservations`
        console.log("reservations: ", reservations);
        console.log("theReservations 111: ", theReservations);
        if (Array.isArray(theReservations)) {
          allTokensPresent = deepEqual(reservations, theReservations);
        }
        // Update only if not all tokens are present
        if (!allTokensPresent || reservations.length === 0) {
          shouldUpdate = true;
        }
      }
      console.log("isReservationsAll: ", isReservationsAll);
      if (shouldUpdate) {
        setTheReservations(isReservationsAll ? allReservations : reservations);
        setSelectedMultipleReservations([]);
        console.log("reservations were updated");
      }
      console.log("allReservations after: ", allReservations);
      console.log("reservations after: ", reservations);
      console.log("theReservations 222:: ", theReservations);
    }
  }, [reservations, allReservations, isAllReservations]);

  useEffect(() => {
    if (theReservations && theReservations.length > 0) {
      console.log("theReservations: ", theReservations);
      console.log("selectedFilters inside: ", selectedFilters);

      // Normalize text function to handle spaces, diacritics, and special characters
      const normalizeText = (text) => {
        return text
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
          .replace(/\W+/g, " ") // Replace non-word characters (symbols, punctuation) with spaces
          .trim();
      };

      const normalizedSearchTerm = normalizeText(searchTerm);
      const searchTokens = normalizedSearchTerm.split(/\s+/); // Split search term by any whitespace (spaces, tabs, etc.)

      // Filter reservations by search term
      const filteredBySearchTerm = theReservations.filter((reservation) => {
        const normalizedFullName = normalizeText(reservation.full_name);
        const normalizedPhoneNumber = normalizeText(reservation.phone_number);
        const normalizedTableNumber = reservation.table_number
          ? normalizeText(reservation.table_number)
          : "";

        return searchTokens.every((token) => {
          return (
            normalizedFullName.includes(token) ||
            normalizedPhoneNumber.includes(token) ||
            normalizedTableNumber.includes(token)
          );
        });
      });

      // Filter reservations by time range
      const filteredByTimeRange = filteredBySearchTerm.filter((reservation) => {
        const reservationTime = reservation.time;

        const formatTime = (time) => {
          if (!time || typeof time !== "string") return "00:00";
          return time.length === 5 ? time : `0${time}`;
        };
        console.log(
          "selectedFilters inside filter useefect: ",
          selectedFilters
        );
        const hasTudo = selectedFilters.includes("tudo");

        if (hasTudo) {
          return true; // Accept all reservations
        }

        return selectedFilters.some((filter) => {
          const startTime = filter.start_time;
          const endTime = filter.end_time;

          return (
            formatTime(reservationTime) >= formatTime(startTime) &&
            formatTime(reservationTime) < formatTime(endTime)
          );
        });
      });

      console.log("filteredByTimeRange: ", filteredByTimeRange);

      // Filter reservations by table place preference
      const filtersWithPlaceOfTable = filteredByTimeRange.filter((filter) => {
        return filter.table_place_preference
          ? placeFilter.includes(filter.table_place_preference.place_of_table)
          : true;
      });

      // Set the final search results
      setSearchResults(filtersWithPlaceOfTable);
    } else {
      setSearchResults(theReservations);
    }
  }, [searchTerm, theReservations, selectedFilters, placeFilter]);

  useEffect(() => {
    if (!searchResults) return;

    const sortOrder = {
      Cancelled_By_Customer_Warning: 0,
      Late: 1,
      Pending_from_customer: 2,
      Pending_from_restaurant: 3,
      Edited: 4,
      Awaiting_customer_reconfirmation: 4,
      Awaiting_customer_reconfirmation_after_message: 4,
      waiting_list: 5,
      Accepted_edit: 6,
      Rejected_edition: 6,
      Accepted_Without_Table: 6,
      Accepted: 6,
      Accepted_With_Table: 6,
      Attended: 8,
      attended: 8,
      Did_Not_Attend: 9,
      Cancelled_By_Customer: 10,
      Cancelled_By_Restaurant: 11,
      Cancelled: 13,
    };

    // Helper to sort results
    const sortReservations = (reservationsToSort) => {
      return [...reservationsToSort].sort((a, b) => {
        const statusOrder =
          (sortOrder[a.status] ?? 999) - (sortOrder[b.status] ?? 999);
        if (statusOrder !== 0) return statusOrder;

        const isValidTableNumber = (tableNumber) => {
          if (tableNumber === null || tableNumber === undefined) return 0;
          const tableNumberStr =
            typeof tableNumber === "string" ? tableNumber : String(tableNumber);
          return tableNumberStr.trim() !== "" &&
            tableNumberStr.trim() !== "null"
            ? 1
            : 0;
        };

        const aHasTableNumber = isValidTableNumber(a.table_number);
        const bHasTableNumber = isValidTableNumber(b.table_number);

        if (!aHasTableNumber && bHasTableNumber) return -1;
        if (aHasTableNumber && !bHasTableNumber) return 1;

        if (dropDownFilterButton === "Horário") {
          const convertTimeToComparableNumber = (timeString) => {
            if (!timeString) return 0;
            const [hours, minutes] = timeString.split(":");
            return parseInt(hours, 10) * 100 + parseInt(minutes, 10);
          };
          const timeA = convertTimeToComparableNumber(a.time);
          const timeB = convertTimeToComparableNumber(b.time);
          return timeA - timeB;
        } else if (dropDownFilterButton === "Grupos maiores") {
          return b.number_of_people - a.number_of_people;
        } else if (dropDownFilterButton === "Grupos menores") {
          return a.number_of_people - b.number_of_people;
        } else if (dropDownFilterButton === "A - Z") {
          return a.full_name.localeCompare(b.full_name);
        }

        return 0;
      });
    };

    // Map selectedStatus to actual backend statuses
    const validStatuses = selectedStatus.flatMap(
      (category) => statusGroups[category] || []
    );

    // Filtered and sorted based on selection
    const filteredResults = searchResults.filter((reservation) =>
      validStatuses.includes(reservation.status)
    );
    const orderedResults = sortReservations(filteredResults);
    setSortedResults(orderedResults);

    // Sorted all status (no filtering)
    const allOrderedResults = sortReservations(searchResults);
    setSortedResultsAllStatus(allOrderedResults);
  }, [searchResults, dropDownFilterButton, selectedStatus]);

  useEffect(() => {
    if (id.date != "null") {
      setDateFilter(id.date);
    }
  }, [id.date]);

  useEffect(() => {
    setTablesList(reservations);
  }, [reservations]);

  useEffect(() => {
    setReservationsWithChatMessages(lastReservationsWithChatMessages);
  }, [lastReservationsWithChatMessages]);

  useEffect(() => {
    console.log("reservationsWithChatMessages: ", reservationsWithChatMessages);
  }, [reservationsWithChatMessages]);

  useEffect(() => {
    if (zones) {
      console.log("zones: ", zones.zones.slice());
      setZonesWithAll((prevState) => {
        const updatedZones = zones.zones.slice();
        return updatedZones;
      });
    }
  }, [dispatch, zones]);

  // choose the right filter according to the time
  useEffect(() => {
    console.log("inside useEffect filters");
    if (fetchedFilters) {
      const checkAndSetFilters = () => {
        const currentDate = new Date();
        const currentHours = currentDate.getHours();
        const currentMinutes = currentDate.getMinutes();

        const normalizeTime = (timeStr) =>
          timeStr === "24:00" ? "23:59" : timeStr;

        const firstMatchingFilter = fetchedFilters.find((filter) => {
          const startTime = new Date(
            `${currentDate.toDateString()} ${normalizeTime(filter.start_time)}`
          );
          const endTime = new Date(
            `${currentDate.toDateString()} ${normalizeTime(filter.end_time)}`
          );

          if (isNaN(startTime) || isNaN(endTime)) {
            console.warn("Invalid date conversion:", filter);
            return false;
          }

          const startHours = startTime.getHours();
          const startMinutes = startTime.getMinutes();
          const endHours = endTime.getHours();
          const endMinutes = endTime.getMinutes();

          const isAfterStartTime =
            currentHours > startHours ||
            (currentHours === startHours && currentMinutes >= startMinutes);
          const isBeforeEndTime =
            currentHours < endHours ||
            (currentHours === endHours && currentMinutes <= endMinutes);

          return isAfterStartTime && isBeforeEndTime;
        });

        if (firstMatchingFilter) {
          setSelectedFilters([firstMatchingFilter]);
        } else {
          setSelectedFilters([]);
        }
      };

      // Check if dateFilter is today
      const selectedDate = new Date(dateFilter);
      const today = new Date();
      const isToday =
        selectedDate.getFullYear() === today.getFullYear() &&
        selectedDate.getMonth() === today.getMonth() &&
        selectedDate.getDate() === today.getDate();

      if (!isToday) {
        // Add "tudo" if it's not today
        setSelectedFilters(["tudo"]);
        console.log("today is today :)");
        return; // Skip interval if not today
      }

      // Run for today
      checkAndSetFilters();
      const intervalId = setInterval(checkAndSetFilters, 30 * 60 * 1000);
      return () => clearInterval(intervalId);
    }
  }, [fetchedFilters, dateFilter]);

  useEffect(() => {
    setPlaceFilter(updatedZones);
  }, [updatedZones, restaurant_id]);

  const dateFilterRef = useRef(dateFilter);
  const placeFilterRef = useRef(placeFilter);
  const statusFilterRef = useRef(statusFilter);

  useEffect(() => {
    dateFilterRef.current = dateFilter;
    placeFilterRef.current = placeFilter;
    statusFilterRef.current = statusFilter;
  }, [dateFilter, statusFilter]);

  const handleCustomFilterChange = (value, filterName) => {
    if (filterName === "status") setStatusFilter(value);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Accepted":
        return "green";
      case "Cancelled":
        return "red";
      case "Pending_from_restaurant":
        return "yellow";
      case "Edited":
        return "purple";
      default:
        return "black";
    }
  };

  const handleResetAttendance = () => {
    dispatch(resetAttendance());
    setShowNoTablesMessage(!showNoTablesMessage);
  };

  const handleShowModal = (value) => {
    if (value) {
      setSelectedReservation(value);
      setTokens(value);
      setCanceltMultipleReservations(false);
    } else {
      setCanceltMultipleReservations(true);
    }
    setShowModal(true);
  };

  const handleAccept = () => {
    if (acceptMultipleReservations) {
      dispatch(postReservationAccept(selectedMultipleReservations, true));
      setSelectedMultipleReservations([]);
    } else {
      dispatch(postReservationAccept(selectedReservation, false));
    }
    setShowAcceptModal(false);
  };

  const handleShowAcceptModal = (value) => {
    if (value) {
      setSelectedReservation(value);
      setAcceptMultipleReservations(false);
    } else {
      const tokensToExclude = new Set(
        theReservations
          .filter((rt) => rt.status === "Accepted" || rt.status === "Cancelled")
          .map((rt) => rt.token)
      );
      const newSelectedMultipleReservations =
        selectedMultipleReservations.filter(
          (token) => !tokensToExclude.has(token)
        );
      setSelectedMultipleReservations(newSelectedMultipleReservations);
      setAcceptMultipleReservations(true);
    }
    setShowAcceptModal(true);
  };

  const handleCloseAcceptModal = () => {
    setShowAcceptModal(false);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleCloseDateModal = () => {
    setShowDateModal(false);
  };

  const handleOpenDateModal = () => {
    setShowDateModal(true);
    dispatch(getReservationSums(restaurants?.id, dateFilter));
  };

  const handleCloseFilterModal = () => {
    setShowFilterModal(false);
  };

  const handleOpenFilterModal = () => {
    setShowFilterModal(true);
  };

  const handleModalSave = (selectedTables, token, ids) => {
    const fullTableInfo = getTableInfo(selectedTables, tables);
    dispatch(changeTables(token, fullTableInfo, ids));
    setShowTablesModal(false);
  };

  const handleOpenCreateReservationModal = (isReservationRetry = false) => {
    setReservationRetry(isReservationRetry);
    setIsReservationModalOpen(true);
    setReservation_or_waiting_list("reservation");
    setReset(!reset);
    setIsCreatingReservation(true);

    setTokens("");
  };

  const handleOpenEditReservationModal = (tokeni) => {
    setIsReservationModalOpen(true);
    setIsCreatingReservation(false);
    setReservation_or_waiting_list("reservation");
    setTokens(tokeni);
  };

  const handleCloseReservationModal = () => {
    setIsReservationModalOpen(false);
    setTokens();
  };

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    setHasSelectedSuggestion(false);
    setIsSugestionActive(false);
  };

  const cleanSearchTerm = (event) => {
    if (isSugestionActive) {
      setIsSugestionActive(false);
      setSearchTerm("");
      console.log("inside suggestion cleaner");
    }
  };

  useEffect(() => {
    console.log("hasSelectedSuggestion useeffeect");
  }, [hasSelectedSuggestion]);

  const handleSelectMultipleReservations = (value) => {
    setSelectedMultipleReservations((prevSelected) => {
      if (prevSelected.includes(value)) {
        return prevSelected.filter((token) => token !== value);
      } else {
        return [...prevSelected, value];
      }
    });
  };
  const handleSelectMultipleReservationsAll = (reservationsList) => {
    // Filter out reservations with status of "Cancelled"
    const filteredReservationsList = reservationsList.filter(
      (r) => r.status !== "Cancelled"
    );

    // Check if all tokens in filteredReservationsList are already in selectedMultipleReservations
    const allTokensPresent = filteredReservationsList.every((r) =>
      selectedMultipleReservations.includes(r.token)
    );

    if (allTokensPresent) {
      // If all tokens are already present, remove them
      const newSelectedMultipleReservations =
        selectedMultipleReservations.filter(
          (token) => !filteredReservationsList.some((r) => r.token === token)
        );
      setSelectedMultipleReservations(newSelectedMultipleReservations);
    } else {
      // Otherwise, add all tokens that are not already present
      const newTokens = filteredReservationsList
        .filter((r) => !selectedMultipleReservations.includes(r.token))
        .map((r) => r.token);
      setSelectedMultipleReservations([
        ...selectedMultipleReservations,
        ...newTokens,
      ]);
    }
  };

  const handleSelectFilters = (newSelectedItems) => {
    setSelectedFilters(newSelectedItems);
    lastManualUpdate.current = new Date().getTime();
  };

  const handleCustomSelectPlaceOfTable = (newSelectedItems) => {
    setPlaceFilter(newSelectedItems);
  };

  const handleSelectStatuses = (items) => {
    setSelectedStatus(items);
  };

  const handleCheckCancel = (token) => {
    dispatch(checkCancelAction(token));
  };

  const updateSearchResultsTableNumber = (id, newTableNumber, status) => {
    setSearchResults((prevResults) => {
      // Find the item with the matching ID
      const foundItem = prevResults.find((item) => item.id === id);

      if (foundItem) {
        // Create a new array with the updated object
        return prevResults.map((item) =>
          item.id === id
            ? { ...item, table_number: newTableNumber, status: status }
            : item
        );
      } else {
        // Handle the case where the item with the given ID is not found
        console.error("Invalid ID. Unable to update search results.");
        return prevResults;
      }
    });
  };

  const handleSetPhoneNumber = (
    country_code,
    phone_number,
    reservationID,
    isPhoneConfirmed,
    the_customer_name,
    reservation_token
  ) => {
    const countryCode = country_code;
    const phoneNumber = phone_number;
    const countryCodeLength = countryCode.length;
    const formattedPhoneNumber = phoneNumber.startsWith(countryCode)
      ? countryCode + " " + phoneNumber.slice(countryCodeLength)
      : phoneNumber;

    setCompletePhone(formattedPhoneNumber);
    setShowPhoneModal(!showPhoneModal);
    setCurrent_reservation_id(reservationID);
    setPhoneIsConfirmed(isPhoneConfirmed);
    setCustomer_name(the_customer_name);
    setReservationTokenToPhoneLink(reservation_token);
  };

  const showCustomerInfo = (country_code, phone_number) => {
    const countryCode = country_code;
    const phoneNumber = phone_number;
    const countryCodeLength = countryCode.length;
    const formattedPhoneNumber = phoneNumber.startsWith(countryCode)
      ? countryCode + " " + phoneNumber.slice(countryCodeLength)
      : phoneNumber;
    setCompletePhone(phone_number);
    setIsShowCustomerInfoModalActive(true);
  };

  // This function is called when a new message is received from the WebSocket
  const handleReservationUpdate = (newReservation) => {
    setTheReservations((currentResults) => {
      const index = currentResults.findIndex(
        (res) => res.token === newReservation.token
      );
      let updatedResults = [...currentResults];

      // Convert both dates to Date objects
      const newReservationDate = new Date(newReservation.date);
      const filterDate = new Date(dateFilterRef.current);
      if (index !== -1) {
        // If reservation exists, update it
        // Compare the year, month, and day parts of the dates
        if (
          newReservationDate.getFullYear() === filterDate.getFullYear() &&
          newReservationDate.getMonth() === filterDate.getMonth() &&
          newReservationDate.getDate() === filterDate.getDate()
        ) {
          // If reservation exist and dates match, update newReservation
          updatedResults[index] = newReservation;
        } else {
          // else remove it
          updatedResults = updatedResults.filter((reservation) => {
            return reservation.token !== newReservation.token;
          });
        }
      } else {
        // Compare the year, month, and day parts of the dates
        if (
          newReservationDate.getFullYear() === filterDate.getFullYear() &&
          newReservationDate.getMonth() === filterDate.getMonth() &&
          newReservationDate.getDate() === filterDate.getDate()
        ) {
          // If reservation doesn't exist and dates match, add newReservation
          updatedResults.push(newReservation);
        }
        // If dates don't match, do not add newReservation
      }
      return updatedResults;
    });
    setAll_reservations((currentResults) => {
      const index = currentResults.findIndex(
        (res) => res.token === newReservation.token
      );
      let updatedResults = [...currentResults];

      if (index !== -1) {
        // If reservation exists, update it
        updatedResults[index] = newReservation;
      } else {
        // If reservation doesn't exist, add it
        updatedResults.push(newReservation);
      }

      // Sort the updated results based on your criteria (e.g., date)
      updatedResults.sort((a, b) => new Date(a.date) - new Date(b.date));

      return updatedResults;
    });
    setReservationsWithChatMessages((current) => {
      // Create a minimal reservation object with only the expected fields
      const normalizedUpdate = {
        id: newReservation.id,
        full_name: newReservation.full_name,
        email: newReservation.email,
        phone_number: newReservation.phone_number,
        date: newReservation.date,
        time: newReservation.time,
        number_of_people: newReservation.number_of_people,
        status: newReservation.status,
        last_chat_message: newReservation.last_chat_message,
        last_chat_sender: newReservation.last_chat_sender,
        chat_has_messages: newReservation.chat_has_messages,
        token: newReservation.token,
        chat_notification_restaurant:
          newReservation.chat_notification_restaurant,
        chat_notification_restaurant_all:
          newReservation.chat_notification_restaurant_all,
      };

      const index = current.findIndex(
        (res) => res.token === normalizedUpdate.token
      );
      let updatedList = [...current];

      if (index !== -1) {
        // Update existing reservation while preserving any additional fields
        updatedList[index] = {
          ...updatedList[index],
          ...normalizedUpdate,
        };

        // Remove from list if it no longer has chat messages
        if (!normalizedUpdate.chat_has_messages) {
          updatedList = updatedList.filter(
            (res) => res.token !== normalizedUpdate.token
          );
        }
      } else if (normalizedUpdate.chat_has_messages) {
        // Only add new reservations with chat messages
        updatedList.unshift(normalizedUpdate); // Add to beginning to maintain reverse chronological order
      }

      // Sort by ID descending (newest first) and limit to 50
      return updatedList.sort((a, b) => b.id - a.id).slice(0, 50);
    });
  };

  const socket = useRef(null);
  const reconnectTimeout = useRef(null); // Store reconnect timeout to avoid multiple timeouts

  useEffect(() => {
    // Wait for `restaurants?.id` to be available
    if (!restaurants?.id) {
      console.log("Waiting for restaurant ID...");
      return; // Skip WebSocket creation if `restaurants.id` is not available
    }

    // Ensure WebSocket is created only once
    if (socket.current) return; // Skip if WebSocket is already created

    const websocketBaseURL = process.env.REACT_APP_WEBSOCKET_URL;

    const connectWebSocket = () => {
      // Create WebSocket connection if not already open
      if (socket.current && socket.current.readyState === WebSocket.OPEN) {
        console.log("WebSocket already connected.");
        return;
      }

      socket.current = new WebSocket(
        `${websocketBaseURL}reser/${restaurants.id}/`
      );
      console.log("socket.current: ", socket.current);

      socket.current.onmessage = (event) => {
        const data = JSON.parse(event.data);

        // Handle reservation updates
        if (data.type === "reservation_update") {
          handleReservationUpdate(data.data);
        }
      };

      socket.current.onopen = () => {
        console.log("WebSocket Connected");
        dispatch_reservation_wait();
        setWebsocketStatus("connected");

        // Clear reconnect timeout if successfully connected
        if (reconnectTimeout.current) {
          clearTimeout(reconnectTimeout.current);
          reconnectTimeout.current = null;
        }
      };

      socket.current.onclose = (event) => {
        console.log("WebSocket Disconnected:", event);
        setWebsocketStatus("error");
        // Reconnect after 5 seconds if the disconnection wasn't manual
        if (event.code !== 1000) {
          reconnectTimeout.current = setTimeout(connectWebSocket, 5000);
        }
      };

      socket.current.onerror = (error) => {
        console.error("WebSocket Error:", error);
        socket.current.close(); // Close to trigger onclose
      };
    };

    connectWebSocket();

    // Cleanup function to close the socket and clear timeout on unmount
    return () => {
      if (reconnectTimeout.current) clearTimeout(reconnectTimeout.current);
      if (socket.current) {
        console.log("Closing WebSocket connection...");
        socket.current.close();
      }
    };
  }, [restaurants?.id, onlineStatus]);

  useEffect(() => {
    const checkReservations = () => {
      if (restaurantTimeZone && restaurants) {
        const currentTime = moment.tz(restaurants.timezone);
        if (!currentTime.isValid()) {
          console.error(
            "Failed to compute valid time for timezone: Europe/London"
          );
          // Consider a fallback or notify users/administrators as appropriate
        }
        console.log(
          "currentTime: ",
          currentTime.format(),
          "Timezone: ",
          currentTime.zoneName()
        );
        const currentTimeToShowAttendance = currentTime
          .clone()
          .add(24, "hours");
        const currentTimeAfter = currentTime.clone().subtract(15, "minutes");

        theReservations.forEach((reservation, index) => {
          const reservationDateTime = moment.tz(
            `${reservation.date} ${reservation.time}`,
            "YYYY-MM-DD HH:mm",
            restaurants.timezone
          );
          // console.log('reservationDateTime: ', reservationDateTime)
          console.log(
            "inside useeffect late currentTimeAfter: ",
            currentTimeAfter.format(),
            "reservationDateTime: ",
            reservationDateTime
          );
          if (
            reservationDateTime.isBefore(currentTimeAfter.format()) &&
            (reservation.status === "Accepted" ||
              reservation.status === "Accepted_edit" ||
              reservation.status === "Awaiting_customer_reconfirmation" ||
              reservation.status === "Rejected_edition" ||
              reservation.status === "Accepted_With_Table" ||
              reservation.status === "Accepted_Without_Table")
          ) {
            console.log("inside here 1");
            dispatch(
              updateReservation(reservation.id, { status: "Late" }, true)
            );
          } else {
            console.log("inside here 2");
          }
        });
      }
    };

    const intervalId = setInterval(checkReservations, 10000); // 60000 is a minute

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [restaurantTimeZone, theReservations, restaurants]);

  useEffect(() => {
    if (restaurants) {
      const now = moment.tz(restaurants.timezone);
      console.log("reservationDateTime: ", now.format());
    }
    const londonTime = moment.tz("Europe/London");
    console.log("Current time in London:", londonTime.format());
  }, [restaurants]);

  const calculateTotalSeats = (tablesUsed) => {
    let totalSeats = 0;

    console.log("tablesUsed: ", tablesUsed);

    // Convert tablesUsed (string of table numbers) into an array of integers
    const tableNumbers = tablesUsed
      .split(",") // Split the string by commas
      .map((tableNumber) => parseInt(tableNumber.trim(), 10)) // Convert each to integer
      .filter((tableNumber) => !Number.isNaN(tableNumber)); // Filter out invalid numbers

    // Retrieve the configurations for each item
    const configValues = Object.values(connectTablesConfig);

    // Define a counter to keep track of the table connections
    let tableConnectionIndex = 0;

    // Iterate through each table number and find the matching table object
    if (all_tables) {
      tableNumbers.forEach((tableNumber, index) => {
        // Find the corresponding table object in all_tables based on table ID
        const tableObj = all_tables.find((table) => table.id === tableNumber);
        if (!tableObj) {
          console.warn(`Table with ID ${tableNumber} not found in all_tables`);
          return; // Skip if table object is not found
        }

        // Extract and convert the number of seats to an integer
        const numberOfSeats = parseInt(tableObj.number_of_seats, 10);
        if (Number.isNaN(numberOfSeats)) {
          console.warn(`Invalid number_of_seats for table ID ${tableNumber}`);
          return; // Skip if number_of_seats is not a valid number
        }

        // Determine the configuration index based on the connection logic:
        // 1st config for 2 tables, 2nd config for 3 tables, 3rd config for 4 tables,
        // and then cycle between 2nd and 3rd configs thereafter.
        let configIndex;
        if (tableConnectionIndex === 0) {
          configIndex = 0; // Use the first config for the initial connection
        } else {
          configIndex = (tableConnectionIndex % 2) + 1; // Alternate between 2nd and 3rd items
        }

        // Retrieve the configuration for the current table connection
        const config = configValues[configIndex];

        // Adjust the number of seats based on the configuration logic
        const adjustedSeats =
          numberOfSeats + (parseInt(config?.number_of_chairs, 10) || 0);

        // Add the adjusted number of seats to the total count
        totalSeats += adjustedSeats;

        // Increment the table connection index after processing the table
        tableConnectionIndex++;
      });
    }

    return totalSeats;
  };

  const UpdatePhoneNumber = () => {
    dispatch(postPhoneOrEmailConfirmation(current_reservation_id, "phone"));
  };

  const handleIsSuggestion = (e) => {
    setSearchTerm(e.target.value);
    setHasSelectedSuggestion(false);
  };

  const handleToReservation = () => {
    setDateFilter(reservation_created.date); // example 2025-06-27
    handleOpenEditReservationModal(reservation_created.token);
  };

  const handleRetryReservation = () => {
    handleOpenCreateReservationModal(true);
  };

  const handleReservationSuccessOrErrorReset = () => {
    dispatch(createReservationSuccessErrorReset());
  };
  return (
    <Container>
      <Row>
        <Col sm={12} md={12} xl={12}>
          <CardHeader>
            <CardHeaderTitle>Reservas</CardHeaderTitle>
          </CardHeader>
          {(isLoading || websocketStatus === "disconnected") && (
            <LoaderComponent activate={isLoading} theSize={"o"} />
          )}
          <StyledCard ref={topContainerRef}>
            <CardTop>
              <Row>
                {!isAllReservations && (
                  <Col xs={6} md={4}>
                    <DateButton onClick={handleOpenDateModal}>
                      <DateButtonLeft>
                        <CalendarSvgIcon
                          width={20}
                          height={20}
                          strokeColor={"#FAF6E9"}
                          style={{ marginLeft: "4px", marginRight: "4px" }}
                        />
                      </DateButtonLeft>

                      <DateButtonRight>
                        <DefaultDate date={dateFilter} />
                      </DateButtonRight>
                      {/* 
                <WeekDayRight>
                  {
                    new Date(dateFilter).toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '')
                  }
                </WeekDayRight> */}
                    </DateButton>
                  </Col>
                )}
                {!isAllReservations && (
                  <Col xs={12} style={{ height: "100%" }}>
                    <FilterButton>
                      <FilterButtonLeft>
                        <FilterSvgIcon
                          width={20}
                          height={20}
                          strokeColor={"#FAF6E9"}
                          style={{ marginLeft: "4px", marginRight: "4px" }}
                        />
                      </FilterButtonLeft>
                      <FilterButtonRight>
                        <Row
                          style={{
                            width: "100%",
                            padding: "0",
                            margin: "0",
                            height: "100%",
                          }}
                        >
                          <Col
                            xl={6}
                            lg={6}
                            xs={12}
                            style={{
                              padding: "0",
                              margin: "0",
                            }}
                          >
                            <TimeColStyled xs={12}>
                              <div
                                onClick={() =>
                                  setIsOpenTimeFilters(!isOpenTimeFilters)
                                }
                              >
                                <ClockSvgIcon
                                  width={20}
                                  height={20}
                                  strokeColor={"#99B0AD"}
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "2px",
                                    marginRight: "5px",
                                    paddingTop: "2px",
                                  }}
                                />
                              </div>

                              <FiltersComponent
                                restaurantId={restaurants?.id}
                                isOpen={isOpenTimeFilters}
                                setIsOpen={setIsOpenTimeFilters}
                              />

                              <CustomSelectArrayOfObjects
                                items={fetchedFilters}
                                onSelectChange={handleSelectFilters}
                                selectedItems={selectedFilters}
                              />
                            </TimeColStyled>
                            <Col
                              xs={12}
                              style={{
                                display: "flex",
                                flexWrap: "nowrap",
                                marginTop: "5px",
                              }}
                            >
                              <ZoneSvgIcon
                                width={20}
                                height={20}
                                strokeColor={"#99B0AD"}
                                style={{
                                  marginLeft: "3px",
                                  marginRight: "4px",
                                }}
                              />
                              <CustomSelectArray
                                items={updatedZones}
                                onSelectChange={handleCustomSelectPlaceOfTable}
                                selectedItems={placeFilter}
                              />
                            </Col>
                          </Col>

                          <SelectableStatusCol xs={12} lg={6} xl={6}>
                            <SelectableStatusOptions
                              onSelectChange={handleSelectStatuses}
                              selectedItems={selectedStatus}
                              reservations={sortedResultsAllStatus}
                            />
                          </SelectableStatusCol>
                        </Row>
                      </FilterButtonRight>
                    </FilterButton>
                  </Col>
                )}

                <Col xs={12}>
                  <CreateZoneButton
                    onClick={() => {
                      handleOpenCreateReservationModal(false);
                    }}
                  >
                    <StyledH7>Reserva</StyledH7>
                    <LargeIconPlus size="xl" icon={faPlus} />
                  </CreateZoneButton>
                </Col>

                <Col
                  xs={7}
                  md={9}
                  lg={10}
                  style={{ display: "flex", paddingRight: "0" }}
                >
                  <SearchBarLeft>
                    <FontAwesomeIcon
                      icon={faSearch}
                      style={{ color: "#FAF6E9" }}
                    />
                  </SearchBarLeft>

                  <SearchBar ref={searchRef}>
                    <SearchInput
                      active={isSugestionActive}
                      type="text"
                      placeholder="Procurar"
                      value={searchTerm}
                      onChange={handleChange}
                      onClick={(e) => cleanSearchTerm(e)}
                    />

                    {searchTerm && (
                      <FontAwesomeIcon
                        icon={faCircleXmark}
                        onClick={() => {
                          setSearchTerm("");
                          setHasSelectedSuggestion(false); // optional if you want
                        }}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#EE754C",
                          cursor: "pointer",
                          fontSize: "18px",
                        }}
                      />
                    )}

                    {searchTerm &&
                      searchResults.length > 0 &&
                      !hasSelectedSuggestion && (
                        <SuggestionBox>
                          {searchResults.slice(0, 4).map((res) => (
                            <SuggestionItem
                              key={res.id}
                              onClick={() => {
                                setSearchTerm(res.full_name);
                                setHasSelectedSuggestion(true);
                                setIsSugestionActive(true);
                              }}
                            >
                              {res.full_name + " " + res.phone_number}
                            </SuggestionItem>
                          ))}
                        </SuggestionBox>
                      )}
                  </SearchBar>
                </Col>

                <Col
                  xs={5}
                  md={3}
                  lg={2}
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    paddingTop: "5px",
                    paddingLeft: "5px",
                  }}
                >
                  <DropdownSortItems
                    options={[
                      "Horário",
                      "Grupos maiores",
                      "Grupos menores",
                      "A - Z",
                    ]}
                    handleOptionChange={setDropDownFilterButton}
                    initialOption={dropDownFilterButton}
                  />
                </Col>
              </Row>
            </CardTop>
          </StyledCard>
          {/* <FilterButtonDropDown selectedOption={dropDownFilterButton} setSelectedOption={setDropDownFilterButton}></FilterButtonDropDown> */}
          {Array.isArray(theReservations) &&
            Array.isArray(selectedMultipleReservations) &&
            selectedMultipleReservations.length > 0 && (
              <StyledCard>
                <CardBottom>
                  <Row>
                    <Col xs={12} className="mb-2">
                      <Row>
                        <Col
                          xs={4}
                          style={{ fontSize: "16px", color: "white" }}
                        >
                          Tudo:
                          <StyledCheckbox
                            className="form-check-input makeItGreen"
                            id="getEmailCheck"
                            onClick={() =>
                              handleSelectMultipleReservationsAll(
                                theReservations
                              )
                            }
                            checked={theReservations
                              .filter((r) => r.status !== "Cancelled")
                              .every((r) =>
                                selectedMultipleReservations.includes(r.token)
                              )}
                            style={{ marginTop: "6px", marginLeft: "5px" }}
                          />
                        </Col>
                        <Col
                          xs={8}
                          className="d-flex justify-content-end"
                          style={{ fontSize: "14px", color: "white" }}
                        >
                          selecionadas: {selectedMultipleReservations.length} /{" "}
                          {
                            theReservations.filter(
                              (r) => r.status !== "Cancelled"
                            ).length
                          }
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={12}>
                      <FormCheck>
                        <div className="d-flex justify-content-end">
                          {theReservations.length > 0 &&
                            theReservations.some(
                              (rt) =>
                                rt.status !== "Accepted" &&
                                rt.status !== "Cancelled"
                            ) && (
                              <Button
                                onClick={() => handleShowAcceptModal(false)}
                                style={{
                                  backgroundColor: "#3de3d8",
                                  color: "white",
                                }}
                              >
                                Aceitar{" "}
                                <FontAwesomeIcon
                                  size="lg"
                                  icon={faSquareCheck}
                                  style={{
                                    color: "#ffffff",
                                    paddingLeft: "5px",
                                  }}
                                />
                              </Button>
                            )}
                          <Button
                            onClick={() => handleShowModal(false)}
                            style={{
                              backgroundColor: "#de6718",
                              color: "white",
                              marginLeft: "10px",
                            }}
                          >
                            Rejeitar{" "}
                            <FontAwesomeIcon
                              size="lg"
                              icon={faRectangleXmark}
                              style={{ color: "#ffffff", paddingLeft: "5px" }}
                            />
                          </Button>
                        </div>
                      </FormCheck>
                    </Col>
                  </Row>
                </CardBottom>
              </StyledCard>
            )}
          <ReservationContainer
            ref={containerRef}
            style={{ height: `${containerHeight}px` }}
          >
            {sortedResults && sortedResults.length > 0 ? (
              <ReservationCard
                reservations={sortedResults}
                reservations_complete={reservations}
                isReservationFromRestaurantScreen={true}
                dispatch_reservation_wait={dispatch_reservation_wait}
              />
            ) : sortedResults && sortedResults.length === 0 ? (
              <p>Sem novas reservas.</p>
            ) : (
              <p> Erro reinicializar página</p>
            )}
          </ReservationContainer>

          {tables && (
            <TablesModal
              show={showTablesModal}
              tables_list={tables}
              onClose={() => setShowTablesModal(false)}
              onSave={handleModalSave}
              initialSelectedTables={usedTables}
              token={tokena}
              id={restaurant_id}
            />
          )}

          <Modal
            show={showPhoneModal}
            onHide={() => setShowPhoneModal(!showPhoneModal)}
          >
            <Modal.Header>Telefonar para cliente:</Modal.Header>
            <Modal.Body>
              {customer_name}{" "}
              <div style={{ fontSize: "20px" }}>
                {completePhone.length > 4 ? (
                  <>
                    {"+" +
                      completePhone.slice(0, 3) +
                      " " +
                      completePhone.slice(3)}
                    <SwitchLabelButton
                      leftText="Não confirmado"
                      rightText="Confirmado"
                      onToggle={UpdatePhoneNumber}
                      defaultState={phoneIsConfirmed}
                    />
                  </>
                ) : (
                  "Sem número de telemóvel associado"
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              {completePhone.length > 4 ? (
                <a
                  href={`tel:${"+" + completePhone}`}
                  style={{ cursor: "pointer" }}
                >
                  <Button>
                    Telefonar
                    <FontAwesomeIcon
                      size="lg"
                      icon={faPhone}
                      style={{ marginLeft: "7px" }}
                    />
                  </Button>
                </a>
              ) : (
                <Button
                  style={{
                    backgroundColor: "gray",
                    border: "none",
                  }}
                >
                  Telefonar
                  <FontAwesomeIcon
                    size="lg"
                    icon={faPhoneSlash}
                    style={{ marginLeft: "7px" }}
                  />
                </Button>
              )}

              <Button
                onClick={() =>
                  handleOpenEditReservationModal(reservationTokenToPhoneLink)
                }
              >
                Editar número de telemóvel
                <FontAwesomeIcon
                  size="lg"
                  icon={faFilePen}
                  style={{ marginLeft: "7px" }}
                />
              </Button>
              <Button
                style={{
                  background: "#EE754C",
                  border: "solid #EE754C 1px",
                }}
                onClick={() => setShowPhoneModal(!showPhoneModal)}
              >
                Cancelar
                <FontAwesomeIcon
                  size="lg"
                  icon={faXmark}
                  style={{ marginLeft: "7px" }}
                />
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showNoTablesMessage}
            onHide={() => setShowNoTablesMessage(!showNoTablesMessage)}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Atenção! Reserva restaurada sem mesas suficientes.
              </Modal.Title>
            </Modal.Header>
            <Modal.Footer>
              <Button variant="success" onClick={handleResetAttendance}>
                ok
              </Button>
            </Modal.Footer>
          </Modal>

          {(selectedReservation || selectedMultipleReservations) && (
            <>
              <Modal show={showAcceptModal} onHide={handleCloseAcceptModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Aceitar Reserva</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Aceitar seguintes reservas:
                  <div className="acceptRejectModal">
                    {Array.isArray(theReservations) &&
                    acceptMultipleReservations ? (
                      <>
                        {theReservations
                          .filter((rt) =>
                            selectedMultipleReservations.includes(rt.token)
                          )
                          .map((rt, index) => (
                            <div key={index}>
                              <p>
                                {rt.full_name} / {rt.date} / {rt.time}
                              </p>
                            </div>
                          ))}
                      </>
                    ) : (
                      <>
                        {Array.isArray(theReservations) &&
                          theReservations
                            .filter((rt) => tokens.includes(rt.token))
                            .map((rt, index) => (
                              <div key={index}>
                                <p>
                                  {rt.full_name} / {rt.date} / {rt.time}
                                </p>
                              </div>
                            ))}
                      </>
                    )}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  {isLoadingAccept ? (
                    <Loader></Loader>
                  ) : (
                    <SuccessButton
                      variant="success"
                      onClick={() => handleAccept()}
                    >
                      Sim
                    </SuccessButton>
                  )}
                  <DangerButton
                    variant="secondary"
                    onClick={handleCloseAcceptModal}
                  >
                    Não
                  </DangerButton>
                </Modal.Footer>
              </Modal>
            </>
          )}
        </Col>
      </Row>
      {isReservationModalOpen && (
        <CustomModal
          scrollable
          show={isReservationModalOpen}
          onHide={() => {
            if (reservationHasBeenModified) {
              setModalReservationModifyReservation(true);
            } else {
              setIsReservationModalOpen(false);
            }
          }}
          title={
            <>{isCreatingReservation ? "Nova reserva" : "Editar reserva"}</>
          }
          body={
            <>
              {isCreatingReservation && (
                <div style={{ marginBottom: "15px" }}>
                  <CustomSelect
                    items={reservation_or_waiting_list_options}
                    onSelectChange={setReservation_or_waiting_list}
                    selectedItem={reservation_or_waiting_list}
                  />
                </div>
              )}

              <ReservationScreen
                from_restaurant={true}
                creating={isCreatingReservation}
                setCreating={setIsCreatingReservation}
                isEditModalOpen={isReservationModalOpen}
                setIsEditModalOpen={setIsReservationModalOpen}
                restaurantId={restaurant_id}
                handleCloseReservationModal={handleCloseReservationModal}
                token_from_restaurant={tokens}
                setTokens={setTokens}
                reset={reset}
                reservation_or_waiting_list={reservation_or_waiting_list}
                setReservationHasBeenModified={setReservationHasBeenModified}
                reservationHasBeenModified={reservationHasBeenModified}
                modalReservationModifyReservation={
                  modalReservationModifyReservation
                }
                setModalReservationModifyReservation={
                  setModalReservationModifyReservation
                }
                no_border={true}
                reservationRetry={reservationRetry}
                setReservationRetry={setReservationRetry}
              />
            </>
          }
        ></CustomModal>
      )}

      {/*       <ShowCustomerInfo
        phone_number={completePhone}
        restaurant_id={restaurants?.id}
        isModalActive={isShowCustomerInfoModalActive}
        setIsModalActive={setIsShowCustomerInfoModalActive}
      /> */}

      {showDateModal && (
        <ConfirmationModal
          show={showDateModal}
          onHide={handleCloseDateModal}
          title="Reservas do mês"
          body={
            <CustomDatePickerReservationSums
              handleTimeChange={(value) => setDateFilter(value)}
              handleCloseDateModal={handleCloseDateModal}
              date={dateFilter}
              restaurant_id={restaurants?.id}
            />
          }
        />
      )}
      <LoaderComponent
        activate={activateLoader || isCheckCancelLoading || isLoadingCancel}
        theSize={"o"}
      />
      <NotificationBell
        restaurant_id={restaurants?.id}
        allReservations={all_reservations}
        reservationsWithChatMessages={reservationsWithChatMessages}
      ></NotificationBell>

      <ConfirmationModal
        show={reservationErrorModal} // Modal is shown if reservationErrorModal is true
        onHide={() => {
          setReservationErrorModal(false); // Close modal
          handleReservationSuccessOrErrorReset();
        }}
        title="Reserva não registada"
        body={
          <>
            <FontAwesomeIcon
              icon={faCircleXmark}
              style={{ color: "#D94B4B" }}
            />{" "}
            Erro ao criar a reserva. Por favor tente novamente.
          </>
        }
        cancelLabel="Fechar"
        confirmLabel="Tentar novamente"
        cancelColor="#99B0AD"
        confirmColor="#EE754C"
        onConfirm={() => {
          setReservationErrorModal(false); // Close success modal on error modal retry
          handleRetryReservation(); // Retry reservation
        }}
      />

      <ConfirmationModal
        show={reservationSuccessModal} // Modal is shown if reservationSuccessModal is true
        onHide={() => {
          setReservationSuccessModal(false); // Close modal
          handleReservationSuccessOrErrorReset();
        }}
        title="Reserva registada"
        body={
          <>
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{ color: "#4CAE4C" }}
            />{" "}
            A reserva foi registada com sucesso.
          </>
        }
        confirmLabel="OK"
        cancelLabel="Editar reserva"
        cancelColor="#99B0AD"
        confirmColor="#EE754C"
        onConfirm={() => {
          setReservationSuccessModal(false); // Close success modal
          handleReservationSuccessOrErrorReset();
        }}
        onCancel={() => {
          handleToReservation(); // Open reservation on cancel
          setReservationSuccessModal(false); // Close modal
          handleReservationSuccessOrErrorReset();
        }}
      />

      <ConfirmationModal
        show={showModalInternetConectionFailure && onlineStatus} // Modal is shown if reservationErrorModal is true
        onHide={() => {
          setShowModalInternetConectionFailure(false); // Close modal
        }}
        title="Erro de conexão"
        body={
          <>
            <FontAwesomeIcon
              icon={faCircleXmark}
              style={{ color: "#D94B4B" }}
            />{" "}
            Erro de ligação. Por favor, verifique a sua conexão à internet e
            tente novamente. Obrigada.
          </>
        }
        confirmLabel={
          <>
            {" "}
            atualizar pagina{" "}
            <FontAwesomeIcon
              icon={faRefresh}
              style={{
                color: "#ffffff",
                paddingTop: "4px",
                paddingLeft: "10px",
              }}
            />{" "}
          </>
        }
        confirmColor="#EE754C"
        onConfirm={() => {
          // Reload the page
          window.location.reload();
        }}
      />
    </Container>
  );

  // ...
}
export default ReservationFromRestaurantScreen;
